import { call, put, takeEvery } from 'redux-saga/effects'

import * as api from 'api'
import {
  FETCH_CONSULTANT,
  FETCH_CONSULTANT_SUCCESS,
  FETCH_CONSULTANT_ERROR,
  UPDATE_CONSULTANT_INTERESTS,
  UPDATE_CONSULTANT_INTERESTS_SUCCESS,
  UPDATE_CONSULTANT_INTERESTS_ERROR,
  UPDATE_CONSULTANT_START_DATE,
  UPDATE_CONSULTANT_START_DATE_SUCCESS,
  UPDATE_CONSULTANT_START_DATE_ERROR,
  UPDATE_USER_INFO,
  UPDATE_USER_INFO_SUCCESS,
  UPDATE_USER_INFO_ERROR,
  FETCH_UNLISTED_CONSULTANTS,
  FETCH_UNLISTED_CONSULTANTS_SUCCESS,
  FETCH_UNLISTED_CONSULTANTS_ERROR,
  APPROVE_CONSULTANT,
  APPROVE_CONSULTANT_SUCCESS,
  APPROVE_CONSULTANT_ERROR,
  HIDE_CONSULTANT,
  HIDE_CONSULTANT_SUCCESS,
  HIDE_CONSULTANT_ERROR,
} from 'actionTypes'

function* fetchConsultant({ consultantId, force }) {
  try {
    const consultant = yield call(api.fetchConsultant, consultantId, force)
    yield put({ type: FETCH_CONSULTANT_SUCCESS, consultantId, consultant })
  } catch ({ message }) {
    yield put({ type: FETCH_CONSULTANT_ERROR, consultantId, message })
  }
}

function* updateConsultantInterests({ consultantId, interests }) {
  try {
    yield call(api.updateConsultantInterests, consultantId, interests)
    yield put({
      type: UPDATE_CONSULTANT_INTERESTS_SUCCESS,
      consultantId,
      interests,
    })
  } catch ({ message }) {
    yield put({
      type: UPDATE_CONSULTANT_INTERESTS_ERROR,
      consultantId,
      interests,
      message,
    })
  }
}

function* updateConsultantStartDate({ consultantId, startDate }) {
  try {
    yield call(api.updateConsultantStartDate, consultantId, startDate)
    yield put({
      type: UPDATE_CONSULTANT_START_DATE_SUCCESS,
      consultantId,
      startDate,
    })
  } catch ({ message }) {
    yield put({
      type: UPDATE_CONSULTANT_START_DATE_ERROR,
      consultantId,
      startDate,
      message,
    })
  }
}

function* updateUserInfo({ consultantId, userInfo }) {
  try {
    const savedUserInfo = yield call(api.updateUserInfo, consultantId, userInfo)
    yield put({
      type: UPDATE_USER_INFO_SUCCESS,
      consultantId,
      userInfo: savedUserInfo,
    })
  } catch ({ message }) {
    yield put({ type: UPDATE_USER_INFO_ERROR, consultantId, userInfo, message })
  }
}

function* fetchUnlistedConsultants() {
  try {
    const consultants = yield call(api.fetchUnlistedConsultants)
    yield put({ type: FETCH_UNLISTED_CONSULTANTS_SUCCESS, consultants })
  } catch ({ message }) {
    yield put({ type: FETCH_UNLISTED_CONSULTANTS_ERROR, message })
  }
}

function* approveConsultant({ consultantId }) {
  try {
    yield call(api.approveConsultant, consultantId)
    yield put({ type: APPROVE_CONSULTANT_SUCCESS, consultantId })
  } catch ({ message }) {
    yield put({ type: APPROVE_CONSULTANT_ERROR, message })
  }
}

function* hideConsultant({ consultantId }) {
  try {
    yield call(api.hideConsultant, consultantId)
    yield put({ type: HIDE_CONSULTANT_SUCCESS, consultantId })
  } catch ({ message }) {
    yield put({ type: HIDE_CONSULTANT_ERROR, message })
  }
}

function* saga() {
  yield takeEvery(FETCH_CONSULTANT, fetchConsultant)
  yield takeEvery(UPDATE_CONSULTANT_INTERESTS, updateConsultantInterests)
  yield takeEvery(UPDATE_CONSULTANT_START_DATE, updateConsultantStartDate)
  yield takeEvery(UPDATE_USER_INFO, updateUserInfo)
  yield takeEvery(FETCH_UNLISTED_CONSULTANTS, fetchUnlistedConsultants)
  yield takeEvery(APPROVE_CONSULTANT, approveConsultant)
  yield takeEvery(HIDE_CONSULTANT, hideConsultant)
}

export default saga



// WEBPACK FOOTER //
// ./src/sagas/consultants.js